import { ActionIcon, ActionIconProps } from "@mantine/core";
import UseIconButtonStyles from "./styles";
import { IconButtonProps } from "./type";

// CHANGED: extend props to include 'type'
const IconButton = (props: ActionIconProps & IconButtonProps & { type?: "button" | "submit" | "reset" }) => {
  const { onClick, color, children, type = "button", ...rest } = props; // CHANGED: default type="button"
  const { classes } = UseIconButtonStyles({ color });

  // CHANGED: forward 'type' to ActionIcon and ensure ActionIcon renders a button element
  return (
    <ActionIcon
      component="button" // make sure it's a <button>
      type={type}        // forward the type
      className={classes.iconButton}
      onClick={onClick}
      {...rest}
    >
      {children}
    </ActionIcon>
  );
};

export default IconButton;
